import { useClassroomAddTasksFolderMutation } from '@app/services/auto-generated/classroom'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Modal,
  TextField,
  Typography,
} from '@common/components'
import errorHandler from '@common/utils/error-handler'
import React from 'react'

const CreateFolderModal = (props) => {
  const { open, onClose } = props
  const [createFolder, { isLoading }] = useClassroomAddTasksFolderMutation()

  const [name, setName] = React.useState('')
  const [checkedOnlyMe, setCheckedOnlyMe] = React.useState(true)
  const [checkedSubs, setCheckedSubs] = React.useState(false)
  const [checkedViaCode, setCheckedViaCode] = React.useState(false)
  const [checkedSubsAi, setCheckedSubsAi] = React.useState(false)
  const [checkedSubsBasic, setCheckedSubsBasic] = React.useState(false)
  const [checkedSubsPremium, setCheckedSubsPremium] = React.useState(false)

  const handleChangeOnlyMe = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedOnlyMe(event.target.checked)
    if (event.target.checked) {
      setCheckedSubs(false)
      setCheckedSubsAi(false)
      setCheckedSubsBasic(false)
      setCheckedSubsPremium(false)
      setCheckedViaCode(false)
    }
  }
  const handleChangeSubs = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedSubs(event.target.checked)
    setCheckedOnlyMe(false)
  }
  const handleChangeViaCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedViaCode(event.target.checked)
    setCheckedOnlyMe(false)
  }
  const handleChangeSubsAi = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedSubsAi(event.target.checked)
    setCheckedOnlyMe(false)
  }
  const handleChangeSubsBasic = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedSubsBasic(event.target.checked)
    setCheckedOnlyMe(false)
  }
  const handleChangeSubsPremium = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedSubsPremium(event.target.checked)
    setCheckedOnlyMe(false)
  }

  const handleCreateFolder = async () => {
    try {
      const visibility: number[] = []
      if (checkedOnlyMe) visibility.push(0)
      if (checkedSubs) visibility.push(1)
      if (checkedSubsAi) visibility.push(2)
      if (checkedSubsBasic) visibility.push(3)
      if (checkedSubsPremium) visibility.push(4)
      if (checkedViaCode) visibility.push(5)
      await createFolder({ addTasksFolderRequest: { name: name, visibility: visibility } })
      onClose()
    } catch (error) {
      console.error(errorHandler(error))
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      paperProps={{
        sx: { width: '400px', height: '500px' },
      }}
    >
      <Box sx={{ padding: '20px' }}>
        <Typography sx={{ fontWeight: '600', marginTop: '10px' }}>Create Folder</Typography>
        <Typography sx={{ fontWeight: '500', marginTop: '10px', fontSize: '15px', mb: 1 }}>
          Folder Name
        </Typography>
        <TextField
          size='small'
          fullWidth
          placeholder='Course 1'
          value={name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setName(event.target.value)
          }}
        />
        <Box
          sx={{
            '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
            display: 'flex',
            justifyContent: 'space-between',
            mt: 2,
          }}
        >
          <Typography sx={{ pt: 1 }}>Visibility</Typography>
          <Box>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label='Only me'
                checked={checkedOnlyMe}
                onChange={handleChangeOnlyMe}
              />
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label='Subscribers (via my homepage)'
                  checked={checkedSubs}
                  onChange={handleChangeSubs}
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label='Subscribers (100% AI)'
                  checked={checkedSubs || checkedSubsAi}
                  onChange={handleChangeSubsAi}
                  sx={{ ml: 2 }}
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label='Subscribers (Basic)'
                  checked={checkedSubs || checkedSubsBasic}
                  onChange={handleChangeSubsBasic}
                  sx={{ ml: 2 }}
                />
              </FormGroup>
              <FormControlLabel
                control={<Checkbox />}
                label='Subscribers (Premium)'
                checked={checkedSubs || checkedSubsPremium}
                onChange={handleChangeSubsPremium}
                sx={{ ml: 2 }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label='Students using my code'
                checked={checkedViaCode}
                onChange={handleChangeViaCode}
              />
            </FormGroup>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            paddingLeft: '20px',
            paddingRight: '20px',
            marginTop: '20px',
          }}
        >
          <Button variant='outlined' sx={{ width: '150px' }} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            sx={{ width: '150px' }}
            onClick={handleCreateFolder}
            loading={isLoading}
            disabled={!name.trim()}
          >
            Create
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default CreateFolderModal
